import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../../admin_resources/css/admin_layout.css";
import "../../../admin_resources/css/admin_common.css";
import "../../../admin_resources/css/admin_style.css";
import ADMIN_HEADER from "../Admin_Header";
import "react-datepicker/dist/react-datepicker.css";
import { ko } from "date-fns/locale"; // 한국어 locale 추가
import { registerLocale } from "react-datepicker";

registerLocale("ko", ko); // 한국어 locale 등록

const Admin_Jisawrite = () => {
  const [name, setName] = useState("");
  const [cell, setCell] = useState("");
  const [email, setEmail] = useState("");
  const [asobiRoot, setAsobiRoot] = useState("12");
  const [asobiRootEtc, setAsobiRootEtc] = useState("");
  const [selectedFileName, setSelectedFileName] = useState(""); // file2의 선택된 파일 이름
  const [, setFile1Name] = useState(""); // file1 이름 상태
  const [, setFile2] = useState(null); // file2 상태
  const [content, setContent] = useState("");

  const [sidoList, setSidoList] = useState([]);
  const [gunguList, setGunguList] = useState([]);
  const [sido, setSido] = useState(""); // 상태 훅 정의
  const [gungu, setGungu] = useState("");
  
  const [permissions, setPermissions] = useState({});

  const handleAsobiRootChange = (event) => {
    setAsobiRoot(event.target.value);
  };

  useEffect(() => {
    const fetchSidoList = async () => {
      try {
        const response = await fetch("/adress/sido");
        const result = await response.json();
        setSidoList(result);
      } catch (error) {
        console.error("Error fetching sido list:", error);
      }
    };

    fetchSidoList();

	  // 관리자 권한 정보 가져오기
	  const adminId = localStorage.getItem("adminId");
	  if (adminId) {
	    fetchPermissions(adminId);
	  }
	}, []);

	const fetchPermissions = async (adminId) => {
	  try {
	    const response = await fetch(`/permissions/${adminId}`); // 권한 확인 API 호출
	    const data = await response.json();
	    setPermissions(data); // 권한 정보를 상태로 설정
	  } catch (error) {
	    console.error("권한 정보를 가져오는 데 실패했습니다.", error);
	  }
	};

  const handleSidoChange = async (event) => {
    const selectedSido = event.target.value;
    console.log("Selected Sido:", selectedSido);
    setSido(selectedSido);

    try {
      const response = await fetch(`/adress/gungu?sido=${selectedSido}`);
      console.log("Fetch URL:", `/adress/gungu?sido=${selectedSido}`); // 추가된 로그
      const result = await response.json();
      console.log(result); // API 응답 확인

      // sigunguName만 추출하여 gunguList에 저장
      const sigunguNames = result.map((gungu) => gungu.sigunguName);
      console.log("Sigungu Names:", sigunguNames); // 추출된 시군구 이름 확인
      setGunguList(sigunguNames);
    } catch (error) {
      console.error("Error fetching gungu list:", error);
      setGunguList([]);
    }
  };

  const handleGunguChange = (event) => {
    const selectedGungu = event.target.value;
    setGungu(selectedGungu);
  };

  useEffect(() => {}, [gunguList]); // gunguList가 변경될 때마다 로그 찍기

  // 파일 선택 함수
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    // 파일이 선택되었을 때
    if (file) {
      setSelectedFileName(file.name);
      const timestamp = new Date()
        .toISOString()
        .replace(/[-:.T]/g, "")
        .slice(0, 14);
      const extension = file.name.split(".").pop();
      setFile1Name(`${timestamp}_.${extension}`); // file1 이름 상태 업데이트
      setFile2(file); // file2 상태 업데이트
    } else {
      setSelectedFileName("");
      setFile1Name(""); // 파일이 선택되지 않은 경우
      setFile2(null); // 잘못된 파일 상태 초기화

      // 파일 입력란 초기화
      fileInputRef.current.value = ""; // useRef로 파일 입력란 초기화
    }
  };

  const fileInputRef = useRef(null); // useRef로 파일 입력란에 대한 참조를 생성

  // 폼 제출 처리
  const handleSubmit = async (e) => {
    e.preventDefault();

    // 등록 확인 창을 띄우기 전에 필수 입력 항목 체크
    if (!name) {
      alert("이름은 필수 입력항목 입니다");
      return;
    }

    // 등록 확인 알림창
    const isConfirmed = window.confirm("등록하시겠습니까?");

    if (!isConfirmed) {
      return; // 사용자가 취소를 선택하면 폼 제출을 중단
    }

    const formData = new FormData();
    formData.append("gubun", "BB06");
    formData.append("name", name);
    formData.append("cell", cell);
    formData.append("email", email);
    formData.append("content", content);
    formData.append("addr1", sido);
    formData.append("addr2", gungu);
    formData.append("sido", sido);
    formData.append("gungu", gungu);
    formData.append("asobiRoot", asobiRoot);
    formData.append("asobiRootEtc", asobiRootEtc);

    try {
      const response = await fetch("/asobiForm", {
        method: "POST",
        body: formData,
      });

      console.log("Response Status: ", response.status);

      if (!response.ok) {
        const errorText = await response.text(); // 서버에서 반환된 에러 메시지 확인
        console.error("Error response text:", errorText);
        throw new Error("네트워크 응답이 올바르지 않습니다.");
      }

      alert("등록이 완료되었습니다.");
      window.location.href = "/admin/form/jisa";
    } catch (error) {
      console.error("에러 발생:", error);
      alert("등록 중 오류가 발생했습니다.");
    }
  };

  return (
    <div>
      <ADMIN_HEADER />
      <div className="admin_write">
        <div className="path-sec">
          HOME &gt; <span className="menu1">데이터 관리</span> &gt;
          <span className="menu2"> 지사장 지원 관리</span>
        </div>
        <table>
          <tr>
            <td>
              <div className="sec-snb">
                <h3 className="snb_tit">데이터 관리</h3>
                <ul className="snb_list">
				{permissions.ent && (
				  <li>
				    <a href="/admin/form/ent">입회신청 관리</a>
				  </li>
				)}
				{permissions.fr && (
				  <li>
				    <a href="/admin/form/fr">창업신청 관리</a>
				  </li>
				)}
				{permissions.franchise && (
				  <li>
				    <a href="/admin/form/franchise">가맹점 관리</a>
				  </li>
				)}
				{permissions.schedule && (
				  <li>
				    <a href="/admin/form/schedule">창업일정 관리</a>
				  </li>
				)}
				{permissions.jisa && (
				  <li className="cur">
				    <a href="/admin/form/jisa">지사장 지원 관리</a>
				  </li>
				)}
				{permissions.q && (
				  <li>
				    <a href="/admin/form/q">앱 문의 관리</a>
				  </li>
				)}
				{permissions.etc_q && (
				  <li>
				    <a href="/admin/form/etc_q">기타문의 관리</a>
				  </li>
				)}
                  {(localStorage.getItem("adminId") === "jiwoo" ||
                    localStorage.getItem("adminId") === "nixona" ||
                    localStorage.getItem("adminId") === "wjdrnr90" ||
                    localStorage.getItem("adminId") === "hyoseon.jang") && (
                    <li>
                      <a href="/admin/form/point">적립금 정산 관리</a>
                    </li>
                  )}
                </ul>
              </div>
            </td>
            <td>
              <div className="bx-top">지사장 지원 등록</div>
              <form
                id="writeform"
                method="post"
                encType="multipart/form-data"
                onSubmit={handleSubmit}
              >
                <div className="tb_01 wr">
                  <table>
                    <tbody>
                      <input type="hidden" name="gubun" value="BB06" />
                      <tr>
                        <th>이름</th>
                        <td>
                          <input
                            name="name"
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="이름을 입력하세요"
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>희망지역</th>
                        <td>
                          <select
                            name="sido"
                            onChange={handleSidoChange}
                            style={{ appearance: "auto" }}
                          >
                            <option value="">시도선택</option>
                            {sidoList.map((sido) => (
                              <option
                                key={sido.sigunguCode}
                                value={sido.sidoName}
                              >
                                {sido.sidoName}
                              </option>
                            ))}
                          </select>
                          <input type="hidden" name="addr1" value={sido} />
                          <select
                            name="gungu"
                            onChange={handleGunguChange}
                            style={{ appearance: "auto", marginLeft: "10px" }}
                          >
                            <option value="">시군구</option>
                            {gunguList.length > 0 ? (
                              gunguList.map((gungu, index) => (
                                <option key={index} value={gungu}>
                                  {gungu} {/* 여기서 gungu는 문자열입니다 */}
                                </option>
                              ))
                            ) : (
                              <option value="">시군구가 없습니다.</option>
                            )}
                          </select>
                          <input type="hidden" name="addr2" value={gungu} />
                        </td>
                      </tr>
                      <tr>
                        <th>연락처</th>
                        <td>
                          <input
                            name="cell"
                            type="text"
                            value={cell}
                            onChange={(e) => setCell(e.target.value)}
                            placeholder="연락처를 입력하세요"
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>이메일</th>
                        <td>
                          <input
                            name="email"
                            type="text"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr className="jisa">
                        <th>유입경로</th>
                        <td>
                          <label>
                            <input
                              type="radio"
                              value="1"
                              name="asobiRoot"
                              checked={asobiRoot === "1"}
                              onChange={handleAsobiRootChange}
                            />
                            네이버 검색
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="2"
                              name="asobiRoot"
                              checked={asobiRoot === "2"}
                              onChange={handleAsobiRootChange}
                            />
                            다음 검색
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="3"
                              name="asobiRoot"
                              checked={asobiRoot === "3"}
                              onChange={handleAsobiRootChange}
                            />
                            구글 검색
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="4"
                              name="asobiRoot"
                              checked={asobiRoot === "4"}
                              onChange={handleAsobiRootChange}
                            />
                            유튜브 광고
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="5"
                              name="asobiRoot"
                              checked={asobiRoot === "5"}
                              onChange={handleAsobiRootChange}
                            />
                            고가네
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="6"
                              name="asobiRoot"
                              checked={asobiRoot === "6"}
                              onChange={handleAsobiRootChange}
                            />
                            알바천국
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="7"
                              name="asobiRoot"
                              checked={asobiRoot === "7"}
                              onChange={handleAsobiRootChange}
                            />
                            배너(뉴스 기사)광고
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="8"
                              name="asobiRoot"
                              checked={asobiRoot === "8"}
                              onChange={handleAsobiRootChange}
                            />
                            아소비 공식카페
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="9"
                              name="asobiRoot"
                              checked={asobiRoot === "9"}
                              onChange={handleAsobiRootChange}
                            />
                            맘카페(지역 카페)
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="10"
                              name="asobiRoot"
                              checked={asobiRoot === "10"}
                              onChange={handleAsobiRootChange}
                            />
                            지인소개
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="11"
                              name="asobiRoot"
                              checked={asobiRoot === "11"}
                              onChange={handleAsobiRootChange}
                            />
                            오프라인(전단지, 현수막)
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="12"
                              name="asobiRoot"
                              checked={asobiRoot === "12"}
                              onChange={handleAsobiRootChange}
                            />
                            기타문의
                            <input
                              name="asobiRootEtc"
                              value={asobiRootEtc}
                              type="text"
                              style={{ width: "10%", marginLeft: "10px" }}
                              onChange={(e) => setAsobiRootEtc(e.target.value)}
                            />
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <th>문의사항</th>
                        <td>
                          <input
                            name="content"
                            value={content}
                            type="text"
                            onChange={(e) => setContent(e.target.value)}
                            placeholder="문의 사항을 입력하세요"
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>첨부파일</th>
                        <td>
                          <label className="file">
                            <input
                              id="upload"
                              name="file2"
                              type="file"
                              className="inputtext"
                              onChange={handleFileChange}
                              ref={fileInputRef}
                            />
                            <i>파일 선택 : </i>
                            <span>
                              {selectedFileName || "선택된 파일 없음"}
                            </span>
                          </label>
                          <p className="ps">
                            {" "}
                            ※ 파일이 여러개인 경우 압축하여 업로드 해주세요.
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="view-btn">
                    <span className="btn custom_s">
                      <button>
                        <Link
                          to="/admin/board/social"
                          style={{ color: "#fff" }}
                        >
                          목록
                        </Link>
                      </button>
                    </span>

                    <div className="btn-right">
                      <span className="btn custom_r">
                        <button type="submit" className="submit-btn">
                          등록
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </form>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default Admin_Jisawrite;
